import gql from 'graphql-tag';

export const pressReleasePostQuery = gql`
  query getPressRelease($slug: ID!) {
    pressRelease(id: $slug, idType: SLUG) {
      content
      date
      excerpt
      featuredImage {
        node {
          altText
          description
          mediaDetails {
            height
            width
          }
          sourceUrl
        }
      }
      featuredImageWidth
      imageSrcset
      title
    }
  }
`;
